<ng-container *ngIf="isNewPlanPage; else planUpgrade">
  <div class="order-app-dialog">
    <p-dialog
      header=""
      [modal]="true"
      [(visible)]="showAccessDialog"
      [style]="{ width: '542px', height: '463px' }"
      [draggable]="false"
      [resizable]="false"
      [closable]="false"
    >
      <order-app-access-dialog (closeDialog)="closeDialog()"></order-app-access-dialog>
    </p-dialog>
  </div>

  <div [ngStyle]="{ filter: showAccessDialog ? 'blur(10px)' : 'none' }">
    <lib-new-plan></lib-new-plan>
    <lib-subscription-plans [isNewCustomerPlan]="isNewPlanPage"></lib-subscription-plans>
  </div>
</ng-container>
<ng-template #planUpgrade>
  <lib-plan-upgrade></lib-plan-upgrade>
  <lib-module-addons></lib-module-addons>
  <lib-subscription-plans></lib-subscription-plans>
  <lib-faqs [isPaddingY]="true"></lib-faqs>
</ng-template>
